import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';
import * as cookie from '../utils/cookie';

export default class DismissableAlert extends Enhancer {
    init() {
        this.get('.close').addEventListener('click', this.setCookie.bind(this));
    }

    setCookie() {
        cookie.set(this.cookieName, 'true');
        this.element.classList.add('d-none');
    }

    get cookieName() {
        return this.getData('cookie-name');
    }
}

EnhancerApp.register('DismissableAlert', DismissableAlert);
